import React, { useEffect, useState } from 'react';
import { Button, Modal, Col, Form, Row, Table, Alert } from 'react-bootstrap';
import { CONCURSOAPI } from '../../../../../const';
import axios from 'axios';
import { Formik } from 'formik';
import * as yup from 'yup';
import es from '../../../../../../src/yup-es';
import { CampoFormik } from '../../../../CompUtils';
import { useDispatch } from 'react-redux';
import { finalize, init } from '../../../../GlobalFeedback/feedbackSlice';
import FormSection from '../../../../CompUtils/FormSection';
import { createUseStyles } from 'react-jss';
import LinkBtn from '../../../../CompUtils/LinkBtn';
import { verPerfilPuesto } from '../../../Gestion/gestionConcursoSlice';

export const MenuOpcionesPuesto = ({ idPuesto = '', pathPerfil = '', withActions = false }) => {
  const dispatch = useDispatch();
  const FILE_TYPES = ['xlsx', 'xls'];
  const [errorMsg, setErrorMsg] = useState('');
  const [perfil, setPerfil] = useState('');
  const [requisitosCargados, setRequisitosCargados] = useState([]);

  function validarTipoArchivoPermitido(value) {
    if (value.name) return FILE_TYPES.includes(value.name.split('.').pop());
    if (value) return FILE_TYPES.includes(value.split('.').pop());
    return false;
  }
  yup.setLocale(es);
  const schemarequisitos = yup.object({
    requisitosFile: yup
      .mixed()
      .test(
        'fileType',
        'Tipo de archivo no soportado',
        (value) => !value || validarTipoArchivoPermitido(value),
      ),
  });
  const initialRequisitos = {
    requisitosFile: {},
  };

  const handleSubmitRequisitos = (formikValues, action) => {
    setErrorMsg('');
    dispatch(init());
    const copy = Object.assign({}, formikValues);
    var formData = new FormData();
    if (copy.requisitosFile) {
      formData.append('file', copy.requisitosFile);
    }
    axios
      .post(`${CONCURSOAPI}/requisitopuesto/loadfile/${idPuesto}`, formData)
      .then((res) => {
        setRequisitosCargados(res.data);
        dispatch(finalize());
      })
      .catch((error) => {
        dispatch(finalize());
        if (error.response) {
          // Request made and server responded
          setErrorMsg(error.response.data.message);
        } else if (error.request) {
          // The request was made but no response was received
          setErrorMsg(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          setErrorMsg(error.message);
        }
      });
  };
  const [showCargaRequisitosModal, setShowCargaRequisitosModal] = useState(false);
  function handleShowCargaRequisitos() {
    obtenerRequisitosCargados();
    setShowCargaRequisitosModal(!showCargaRequisitosModal);
  }
  const FILE_TYPES_PERFIL = ['pdf', 'PDF'];
  function validarTipoArchivoPerfil(value) {
    if (value.name) return FILE_TYPES_PERFIL.includes(value.name.split('.').pop());
    if (value) return FILE_TYPES_PERFIL.includes(value.split('.').pop());
    return false;
  }
  const schemaperfiles = yup.object({
    perfilesFile: yup
      .mixed()
      .test(
        'fileType',
        'Tipo de archivo no soportado',
        (value) => !value || validarTipoArchivoPerfil(value),
      ),
  });
  const initialPerfiles = {
    perfilesFile: {},
  };
  const handleSubmitPerfiles = (formikValues, action) => {
    setErrorMsg('');
    dispatch(init());
    const copy = Object.assign({}, formikValues);
    var formData = new FormData();
    if (copy.perfilesFile) {
      formData.append('file', copy.perfilesFile);
    }
    axios
      .post(`${CONCURSOAPI}/puesto/file/perfil/${idPuesto}`, formData)
      .then((res) => {
        setPerfil(res.data);
        dispatch(finalize());
      })
      .catch((error) => {
        dispatch(finalize());
        if (error.response) {
          // Request made and server responded
          setErrorMsg(error.response.data.message);
        } else if (error.request) {
          // The request was made but no response was received
          setErrorMsg(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          setErrorMsg(error.message);
        }
      });
  };
  const [showCargaPerfilesModal, setShowCargaPerfilesModal] = useState(false);
  function handleShowCargaPerfiles() {
    setShowCargaPerfilesModal(!showCargaPerfilesModal);
  }

  function handleClose() {
    setShowCargaPerfilesModal(false);
    setShowCargaRequisitosModal(false);
  }

  const obtenerRequisitosCargados = () => {
    axios
      .get(`${CONCURSOAPI}/concursos-publicados/requisitos/puesto/${idPuesto}`)
      .then((res) => {
        setRequisitosCargados(res.data);
      })
      .catch((error) => {
        dispatch(finalize());
        if (error.response) {
          // Request made and server responded
          setErrorMsg(error.response.data.message);
        } else if (error.request) {
          // The request was made but no response was received
          setErrorMsg(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          setErrorMsg(error.message);
        }
      });
  };
  useEffect(() => {
    obtenerRequisitosCargados();
    setPerfil(pathPerfil);
  }, []);

  return (
    <>
      <div className="d-grid gap-2">
        <Button
          size="sm"
          style={{ marginLeft: 'auto' }}
          variant="primary"
          onClick={handleShowCargaRequisitos}>
          Requisitos
        </Button>
        <br />
        <Button
          size="sm"
          style={{ marginLeft: 'auto' }}
          variant="success"
          onClick={handleShowCargaPerfiles}>
          Perfíl
        </Button>
      </div>

      {/* Modal Carga Requisitos */}
      <Modal show={showCargaRequisitosModal} size="lg" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Carga Archivo de Requisitos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {withActions && (
            <Formik
              validationSchema={schemarequisitos}
              validateOnChange={false}
              initialValues={initialRequisitos}
              onSubmit={handleSubmitRequisitos}>
              {(formik) => (
                <Form noValidate onSubmit={formik.handleSubmit} id="cargaRequisitosForm">
                  <Form.Group className="align-items-center">
                    <Row>
                      <Col sm="9">
                        <CampoFormik
                          type="file"
                          label="Archivo de Requisitos a importar"
                          name="requisitosFile"
                          formik={formik}
                          col={{ sm: 4 }}
                        />
                      </Col>
                      <Col sm="1">
                        <Button variant="primary" type="submit">
                          <i className="icono-arg-nube-subir-datos"></i>
                        </Button>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <p className="text-danger">
                          <small>{errorMsg}</small>
                        </p>
                      </Col>
                    </Row>
                  </Form.Group>
                </Form>
              )}
            </Formik>
          )}
          <FormSection></FormSection>
          {requisitosCargados.length > 0 && (
            <TableRequisistos requisitos={requisitosCargados}></TableRequisistos>
          )}
          {requisitosCargados.length === 0 && (
            <Alert variant="danger">No hay requisitos cargados</Alert>
          )}
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      {/* Modal Carga Perfiles */}
      <Modal show={showCargaPerfilesModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Carga Archivo de Perfiles</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {withActions && (
            <Formik
              validationSchema={schemaperfiles}
              validateOnChange={false}
              initialValues={initialPerfiles}
              onSubmit={handleSubmitPerfiles}>
              {(formik) => (
                <Form noValidate onSubmit={formik.handleSubmit} id="cargaPuestosForm">
                  <Form.Group as={Row} className="align-items-center">
                    <Col sm="9">
                      <CampoFormik
                        type="file"
                        label="Archivo de Perfiles a importar"
                        name="perfilesFile"
                        formik={formik}
                        col={{ sm: 4 }}
                      />
                    </Col>
                    <Col sm="1">
                      <Button variant="primary" type="submit">
                        <i className="icono-arg-nube-subir-datos"></i>
                      </Button>
                    </Col>
                    <Col sm="2">
                      <p className="text-danger">
                        <small>{errorMsg}</small>
                      </p>
                    </Col>
                  </Form.Group>
                </Form>
              )}
            </Formik>
          )}
          <FormSection></FormSection>
          {perfil !== '' && perfil != null && (
            <>
              <PerfilBtn className="text-center align-middle" idPuesto={idPuesto}></PerfilBtn>
            </>
          )}
          {perfil === '' ||
            (perfil == null && <Alert variant="danger">No hay perfíl cargado</Alert>)}
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};
const PerfilBtn = (idPuesto = '') => {
  const dispatch = useDispatch();
  const handleViewPerfil = () => {
    dispatch(
      verPerfilPuesto({
        idPuesto: idPuesto.idPuesto,
      }),
    );
  };
  return (
    <LinkBtn onClick={handleViewPerfil} size="sm" transparent>
      <h5 className="text-center">Archivo Perfil</h5>
    </LinkBtn>
  );
};
const TableRequisistos = ({ requisitos }) => {
  const classes = createUseStyles({
    scrollable: {
      overflow: 'scroll',
      height: '500px',
    },
  })();
  return (
    <div className="container-fluid">
      <div className={classes.scrollable}>
        <Table bordered hover size="sm">
          <thead>
            <tr>
              <th className="text-center align-middle">Nombre</th>
              <th className="text-center align-middle">Descripción</th>
              <th className="text-center align-middle">Requerido</th>
              {/* <th className="text-center align-middle">Excluyente</th> */}
            </tr>
          </thead>

          <tbody>
            {requisitos.map((requisito, i) => {
              return <RowRequisito requisito={requisito} key={i}></RowRequisito>;
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

const RowRequisito = ({ requisito = {}, key = '' }) => {
  return (
    <>
      <tr key={key} className="align-items-center">
        <td className="align-middle">{requisito.nombre}</td>
        <td className="align-middle">{requisito.descripcion}</td>
        <td className="align-middle text-center">
          {requisito.requerido || requisito.excluyente ? 'X' : ''}
        </td>
        {/* <td className="text-center align-middle">{requisito.escluyente ? 'X' : ''}</td> */}
      </tr>
    </>
  );
};
